import { render, staticRenderFns } from "./aspect-info.vue?vue&type=template&id=57d55b86"
import script from "./aspect-info.vue?vue&type=script&lang=js"
export * from "./aspect-info.vue?vue&type=script&lang=js"
import style0 from "./aspect-info.vue?vue&type=style&index=0&id=57d55b86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports